import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ConsumerSidebarComponent } from '../sidebar/consumer-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { DelegateComponent } from '../../shared/components/delegate/delegate.component';

@Component({
  selector: 'app-consumer-delegate',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    ConsumerSidebarComponent,
    PageHeaderComponent,
    DelegateComponent,
  ],
  templateUrl: './delegate.component.html',
  styleUrl: './delegate.component.scss',
})
export class ConsumerDelegateComponent {}



